import AirDatepicker from 'air-datepicker'
import localeEn from 'air-datepicker/locale/en'
import format from 'date-fns/format'

const localeIs = {
  daysMin: ['Su', 'Má', 'Þr', 'Mi', 'Fi', 'Fö', 'La'],
  months: [
    'Janúar',
    'Febrúar',
    'Mars',
    'Apríl',
    'Maí',
    'Júní',
    'Júlí',
    'Ágúst',
    'September',
    'Október',
    'Nóvember',
    'Desember',
  ],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maí', 'Jún', 'Júl', 'Ágú', 'Sep', 'Okt', 'Nóv', 'Des'],
  today: 'Í dag',
  clear: 'Hreinsa',
  dateFormat: 'dd.MM.yyyy',
  timeFormat: 'hh:mm aa',
}

const localeEns = {
  ...localeEn,
  dateFormat: 'dd.MM.yyyy',
}

const Datepicker = {
  init: (target) => {
    const { lang } = document.documentElement
    const val = new Date()
    target.value = format(val, 'dd.MM.yyyy')

    const disabledDays = target.dataset.disableddays ? target.dataset.disableddays.split(',') : []

    new AirDatepicker(`#${target.id}`, {
      locale: lang === 'is' ? localeIs : localeEns,
      firstDay: 0,
      dateFormat: 'dd.MM.yyyy',
      startDate: new Date(),
      selectedDates: [val],
      minDate: new Date(),
      onRenderCell({ date }) {
        const dateStr = `${('0' + date.getDate()).slice(-2)}.${('0' + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear()}`

        const day = date.getDay()

        console.log(dateStr);

        const isDisabled = disabledDays.indexOf(dateStr) !== -1 || day === 6 || day === 0
        return {
          disabled: isDisabled,
        }
      },
    })
  },
}

export default Datepicker
